export var IngestionRuntime;
(function (IngestionRuntime) {
    IngestionRuntime["INGESTION_RUNTIME_FLINK"] = "FLINK";
    IngestionRuntime["INGESTION_RUNTIME_NATIVE_STREAM"] = "NATIVE_STREAM";
})(IngestionRuntime || (IngestionRuntime = {}));
